import { useState, useEffect } from "react";
import { HandySvg } from 'handy-svg';
import { Link } from 'react-router-dom';
import iconCross from '../../assets/icons/svg-sprite/close-cross--small.svg';
import iconAttention from '../../assets/icons/svg-sprite/attention.svg';
import iconPointerLeft from '../../assets/icons/svg-sprite/point-arrow-left.svg';
import Aside from '../../components/aside/Aside';
import uniteller from '../../assets/icons/payment-methods/uniteller.png';
import { cards } from '../../lib/api/api';
import closeBanner from "../../modules/close-banner";

const AutopaymentContent = ({ message }) => {
    const [ID, setID] = useState(0);
    const [status, setStatus] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        closeBanner();
        cards.userCard()
            .then((res) => {
                setID(res[0].id);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        if (ID !== 0) {
            submitForm();
            autopaymentToggler();
        }
    }, [ID]);

    function submitForm() {
        const formElement = document.getElementById('autopaymentForm')
        formElement.addEventListener('submit', (e) => {
            e.preventDefault();
            const submitButton = formElement.querySelector("button[type='submit']");
            cards.recurrent(ID, Number(submitButton.value))
                .then(() => {
                    autopaymentToggler();
                })
                .catch((err) => {
                    console.log(err);
                });
        });
    }

    function autopaymentToggler() {
        cards.card(ID)
            .then((res) => {
                const autopayment = res.permissions.filter(item => item.name === 'card.recurrent.uniteller');
                setStatus(autopayment.length);
                setLoading(true);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <>
            {!loading && <div className="preloader__wrapper" />}
            <div className="content__article-wrap" style={ loading ? {} : { overflow: "hidden", height: "0px", margin: 0 } }>
	            <article className="step-process-article">
		            <div className="step-process-article__inner content-columns page-container">
			            <div className="step-process-article__main content-columns__main">
				            <div className="cart__header">
					            <div className="cart__header-inner">
						            <Link className="cart__return" to="/">
                                        <HandySvg className="svg-icon cart__return-icon" src={iconPointerLeft} width="18" height="10"/>
							            <span className="cart__return-text">Вернуться на главную</span>
						            </Link>
						            <h1 className="cart__title title title--h2">Услуга «Автоплатеж»</h1>
					            </div>
				            </div>
                            <div className="wysiwyg">
                                <p style={{marginBottom: 30}}>Подключите «Автоплатеж» и ваши подписки будут автоматически продлеваться с банковской карты или электронных кошельков, на сумму необходимую для оплаты ранее заказанных вами услуг.<br/><br/>Рекомендуем подключать услугу абонентам, которые в случае несвоевременной оплаты не смогут пользоваться акционнами предложениями «Телекарты».</p>
                                <div className="tab-options tab-options__autopay">
                                    <form id='autopaymentForm'>
                                        <ul className="tab-options__list">
                                            <li className="tab-options__item">
                                                <button name="status" value="1" className={"tab-options__btn bttn" + (status ? " tab-options__btn--active" : "")} type={status ? 'button' : 'submit'}>{status ? 'Услуга подключена' : 'Подключить услугу?'}</button>
                                            </li>
                                            <li className="tab-options__item">
                                                <button name="status" value="0" className={"tab-options__btn bttn" + (status ? "" : " tab-options__btn--active")} type={status ? 'submit' : 'button'}>{status ? 'Отключить услугу?' : 'Услуга отключена'}</button>
                                            </li>
                                        </ul>
                                    </form>
                                </div>
                                <div className="content__article-wrap">
                                    <div className="article-logo-items">
                                        <div className="article-logo-items__inner content-columns page-container">
                                            <div className="article-logo-items__main content-columns__main">
                                                <div className="wysiwyg">
                                                    <h3>Платежные системы</h3>
                                                    <p>При подключенной услуге «Автоплатеж» автоматическое продление услуг будет доступно в следующих платежных системах, после первого успешного платежа!</p>
                                                </div>
                                                <div className="logo-items">
                                                    <ul className="logo-items__list">
                                                        <li className="logo-items__item">
                                                            <a className="logo-item js-logo-item-tooltip tooltipstered" href="javascript:void(0)" data-tooltip-content="#paysystem_uniteller">
                                                                <div className="logo-item__logo">
                                                                    <img src={uniteller} width="40" height="40" alt="Uniteller"/>
                                                                </div>
                                                                <div className="logo-item__name">Uniteller</div>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="tooltipster-templates">
                                                    <div className="logo-item__tooltip" id="paysystem_uniteller">
                                                        <div className="logo-item__tooltip-title">Uniteller</div>
                                                        <div className="logo-item__tooltip-description">
                                                            <p>Оплативайте подписки через платежную систему Uniteller. Если услуга «Автоплатеж» подключена, в дальнейшем баланс будет пополняться автоматически</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
				            </div>
                            <div id='messageBanner' className="info-cards__message-container js-closing-banner is-active" style={{display: 'none'}}>
                                <div className="info-cards__message">
                                    <div className="info-cards__message-content">
                                        <HandySvg className="svg-icon" src={iconAttention} width="36" height="36"/>
                                        <div className="info-cards__message-text">{message}</div>
                                    </div>
                                    <button className="js-close-btn info-cards__message-btn" type="button">
                                        <HandySvg className="svg-icon" src={iconCross} width="13" height="12"/>
                                    </button>
                                </div>
                            </div>
			            </div>
                        <aside className="common-article__aside content-columns__aside" style={{marginTop: 50}}>
                            <div className="content-columns__aside-cell">
                                <Aside/>
                            </div>
                        </aside>
                    </div>
	            </article>
            </div>
        </>
    );
};

export default AutopaymentContent;